<template>
  <v-card
      class="card-geral mx-auto"
  >
    <v-container>
      <v-row dense class="py-5">

        <v-col
            v-for="(item, i) in items"
            :key="i"
            cols="12"
            md="6"
        >
          <v-card
              style="background-color: beige;"
              dark
          >
            <router-link :to="{ name: item.link }" style="text-decoration: none;" v-if="item.level && item.admin && item.level.includes(nivel) && item.admin.includes(admin)">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div class="d-flex justify-center">
                  <v-card-title
                      style="color: burlywood;"
                      class="text-h5 d-flex"
                      v-text="item.title"
                  ></v-card-title>
                </div>
                <v-avatar
                    class="ma-3"
                    size="125"
                    tile
                >
                  <v-icon style="color: burlywood;" :size="item.size">
                    {{ item.icon }}
                  </v-icon>
                </v-avatar>
              </div>
            </router-link>
            
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import session from "js-cookie";

export default {
  data: () => ({
    items: [
      {
        link: 'geral-candidato',
        title: 'PROCESSO SELETIVO',
        icon: 'mdi-account-hard-hat',
        size: 80,
        admin: [0,1],
        level: [1,3]
      },
      {
        link: 'geral-treinamento-professor',
        title: 'TREINAMENTO DOS PROFESSORES',
        icon: 'mdi-school',
        size: 80,
        admin: [1],
        level: [3]
      },
      {
        link: 'geral-remuneracao-professor',
        title: 'REMUNERAÇÃO DOS PROFESSORES',
        icon: 'mdi-currency-usd',
        size: 80,
        admin: [0,1],
        level: [2,3]
      },
      {
        link: 'geral-relatorio',
        title: 'RELATÓRIOS',
        icon: 'mdi-file-cog',
        size: 65,
        admin: [1],
        level: [1,3]
      },
    ],

    admin: parseInt(session.get('_admin')),
    nivel: parseInt(session.get('_nivel_id')),
  })
}
</script>

<style scoped>

.card-geral{

  padding-top: 20px;
}

@media screen and (max-width: 730px) {

  .card-geral{

    padding-top: 0;
  }
}

@media screen and (max-width: 458px) {

  .card-geral{

    padding-top: 20px;
  }
}
</style>
